<script>
import BodyHome from "@/components/body/home/BodyHome";
import BodyFarm from "@/components/body/farm/BodyFarm";
import BodyTeam from "@/components/body/team/BodyTeam";
import BodyProducts from "@/components/body/products/BodyProducts";
import BodyAgenda from "@/components/body/agenda/BodyAgenda";
import BodyEvent from "@/components/body/event/BodyEvent";
import BodyContact from "@/components/body/contact/BodyContact";

export default {
  name: "PageContent",
  components: {
    BodyHome,
    BodyFarm,
    BodyTeam,
    BodyProducts,
    BodyAgenda,
    BodyEvent,
    BodyContact
  }
};
</script>

<style lang="stylus" scoped>
.site-body
  overflow hidden
  position relative
</style>
